import { mergeIconColorVars as e } from "../icon-props.js";
import { jsx as t } from "react/jsx-runtime";
//#region src/icons/align-right.tsx
function n({ colors: n, style: r, ...i }) {
	return /* @__PURE__ */ t("svg", {
		viewBox: "0 0 24 24",
		fill: "none",
		"aria-hidden": "true",
		focusable: "false",
		xmlns: "http://www.w3.org/2000/svg",
		style: {
			...e(n),
			...r
		},
		...i,
		children: /* @__PURE__ */ t("path", {
			d: "M21 17C21.5523 17 22 17.4477 22 18C22 18.5523 21.5523 19 21 19H8C7.44772 19 7 18.5523 7 18C7 17.4477 7.44772 17 8 17H21ZM21 13C21.5523 13 22 13.4477 22 14C22 14.5523 21.5523 15 21 15H4C3.44772 15 3 14.5523 3 14C3 13.4477 3.44772 13 4 13H21ZM21 9C21.5523 9 22 9.44772 22 10C22 10.5523 21.5523 11 21 11H8C7.44772 11 7 10.5523 7 10C7 9.44772 7.44772 9 8 9H21ZM21 5C21.5523 5 22 5.44772 22 6C22 6.55228 21.5523 7 21 7H4C3.44772 7 3 6.55228 3 6C3 5.44772 3.44772 5 4 5H21Z",
			fill: "var(--icon-color-primary, currentColor)"
		})
	});
}
//#endregion
export { n as AlignRightIcon };
